<template>
    <div>
        <loading v-show="isLoading"></loading>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+(bodyHeight-100)+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:200px;margin-left:30px;"
                            placeholder="请输入APP名称"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    :height="bodyHeight-200"
                    v-loading="isLoading"
                    :data="tableData"
                    style="width: 100%">
                            <el-table-column
                            width="100"
                                label="AppLogo">
                                <template slot-scope="scope">
                                        <el-image
                                        style="width: 30px; height: 30px"
                                        :src="scope.row.AppIcon"
                                        fit="fill"></el-image>
                                </template>
                            </el-table-column>
                             <el-table-column
                             width="150"
                                prop="AppName"
                                label="App名称">
                            </el-table-column>
                            <el-table-column
                                prop="Description"
                                label="任务描述">
                            </el-table-column>
                            <el-table-column
                            width="90"
                                label="收入">
                               <template slot-scope="scope">
                                    <el-tag size="mini" effect="dark" type="danger">￥{{scope.row.Income}}</el-tag>
                               </template>
                            </el-table-column>
                            <el-table-column
                            width="90"
                                label="成本">
                                <template slot-scope="scope">
                                    <el-tag size="mini" effect="dark" type="success">￥{{scope.row.Cost}}</el-tag>
                               </template>
                            </el-table-column>
                            <el-table-column
                                prop="DeliverDescription"
                                label="交单描述">
                            </el-table-column>
                            <el-table-column
                            width="120"
                                label="交单示例图片">
                                <template slot-scope="scope">
                                      <el-link @click="showImg(scope.row.DeliverExampleList)" type="primary">点击查看</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                            width="90"
                                label="销量">
                                <template slot-scope="scope">
                                    <el-tag size="mini" effect="plain" type="">{{scope.row.Sales}}</el-tag>
                               </template>
                            </el-table-column>
                            <el-table-column
                            width="90"
                                label="状态">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.IsUse" size="mini"  type="success">正常</el-tag>
                                    <el-tag v-else size="mini"   type="danger">停用</el-tag>
                               </template>
                            </el-table-column>
                            <el-table-column
                            width="90"
                                label="步骤">
                                 <template slot-scope="scope">
                                      <el-link @click="setSetp(scope.row)" type="primary">点击查看</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                            width="150"
                                label="操作">
                                <template slot-scope="scope"> 
                                    <el-button @click="update(scope.row)" type="primary" size="small" icon="el-icon-edit" circle></el-button>
                                </template>
                            </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-drawer
        :with-header="false"
        size="800px"
        direction="ltr"
  title="编辑任务"
  :visible.sync="addVisible">
  <el-scrollbar :style="'height:'+bodyHeight+'px'">
<el-form :model="model"  style="width:90%;margin-top:20px" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="APP名称：" prop="AppName">
                    <el-input size="small"   placeholder="请输入APP名称"  v-model="model.AppName"></el-input>
                </el-form-item>
                <el-form-item label="APP图标：" >
                            <el-upload 
                            :file-list="iconList"
                            :action="baseUrl+'/TaskOther/PushImg'"
                            list-type="picture-card"
                            :limit="1"
                            :on-preview="handlePictureCardPreview"
                            :on-success="pushIcon"
                            accept="image/jpeg,image/jpg,image/png"
                            :multiple="false"
                            :on-exceed="exceed"
                            :on-remove="iconRemove">
                            <i class="el-icon-plus" ></i>
                            </el-upload>
                  </el-form-item>
                <el-form-item label="销量：" prop="Sales">
                    <el-input size="small"   placeholder="请输入销量"  v-model="model.Sales"></el-input>
                </el-form-item>
                <el-form-item label="是否启用：" >
                    <el-switch
                    v-model="model.IsUse"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="收入：" prop="Income">
                    <el-input size="small"   placeholder="请输入收入"  v-model="model.Income"></el-input>
                </el-form-item>
                <el-form-item label="成本：" prop="Cost">
                    <el-input size="small"   placeholder="请输入成本"  v-model="model.Cost"></el-input>
                </el-form-item>

                <el-form-item label="任务描述：" prop="Description">
                    <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入任务描述"
                    v-model="model.Description">
                    </el-input>
                </el-form-item>
                <el-form-item label="交单描述：" prop="DeliverDescription">
                    <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入交单描述"
                    v-model="model.DeliverDescription">
                    </el-input>
                </el-form-item>
                <el-form-item label="交单示例图片：">
                            <el-upload 
                            
                            :file-list="deliverExampleList"
                            :action="baseUrl+'/TaskOther/PushImg'"
                            list-type="picture-card"
                            :limit="10"
                            :on-preview="handlePictureCardPreview"
                            :on-success="pushDeliver"
                            accept="image/jpeg,image/jpg,image/png"
                            :multiple="false"
                            :on-exceed="exceed"
                            :on-remove="deliverRemove">
                            <i class="el-icon-plus" ></i>
                            </el-upload>
                  </el-form-item>

            </el-form>
            <div style="text-align:center;margin-bottom:20px" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAction">确 定</el-button>
            </div>
  </el-scrollbar>

  
</el-drawer>
        <el-drawer
        :with-header="false"
        size="800px"
        direction="rtl"
    title="步骤"
  :visible.sync="stepVisible">
  <el-scrollbar :style="'height:'+bodyHeight+'px;'">
      <div style="padding-top:20px;padding-bottom:20px;padding-right:30px">
        <el-timeline>
            <el-timeline-item v-for="(v,i) in setRow.StepList" :key="i" :timestamp="'第 '+(i+1)+' 步'" placement="top">
                <el-input
                type="textarea"
                style="margin-bottom:20px"
                :rows="2"
                placeholder="请输入步骤描述"
                v-model="v.Text">
                </el-input>
                <el-upload 
                    :file-list="stepFileList[i]"
                    :action="baseUrl+'/TaskOther/PushStepImg?index='+i"
                    list-type="picture-card"
                    :limit="10"
                    :on-preview="handlePictureCardPreview"
                    :on-success="pushStepImg"
                    accept="image/jpeg,image/jpg,image/png"
                    :multiple="false"
                    :on-exceed="exceed"
                    :on-remove="stepRemove">
                    <i class="el-icon-plus" ></i>
                </el-upload>
            </el-timeline-item>
        </el-timeline>
          <el-button size="small" icon="el-icon-plus" @click="addStep" style="margin-left:9%" type="primary">添加步骤</el-button>
          <el-button size="small" icon="el-icon-check" @click="saveStep" style="margin-left:20px" type="success">保存</el-button>
      </div>

  </el-scrollbar>
</el-drawer>
            <el-image-viewer 
            style="z-index:9999999"
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="imgList" />
    </div>
</template>
<script>
const validateAcquaintance = (rule, value, callback) => {
  if (value < 1 || value > 1000) {
    callback(new Error('金额必须在 1 至 1000 之间'))
  } else {
    callback()
  }
}
import {taskOtherSave,taskOtherGet,uri,taskOtherSaveStep } from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    data(){
        return {
            stepFileList:[],
            setRow:{},
            stepVisible:false,
            iconList:[],
            deliverExampleList:[],
            imgList:[],
            baseUrl:uri,
            showViewer:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            addVisible:false,
            model:{
                Id:0,
                AppIcon:"",
                AppName:"",
                Description:"",
                Income:0,
                Cost:0,
                DeliverDescription:"",
                DeliverExampleList:[],
                Sales:0,
                IsUse:false,
            },
            rules: {
                AppIcon: [
                    { required: true, message: '请上传APP图标', trigger: 'blur' },
                ],
                AppName: [
                    { required: true, message: '请填写APP名称', trigger: 'blur' }
                ],
                Description: [
                    { required: true, message: '请填写任务描述', trigger: 'blur' }
                ],
                Income: [
                    { required: true, message: '请填写收入',trigger: 'blur'},
                    { validator: validateAcquaintance, trigger: 'blur'}        
                ],
                Cost: [
                    { required: true, message: '请填写成本',trigger: 'blur'},
                    { validator: validateAcquaintance, trigger: 'blur'}        
                ],
                Sales: [
                    { required: true, message: '请填写销量',trigger: 'blur'},
                ],
                DeliverDescription: [
                    { required: true, message: '请填写交单描述',trigger: 'blur'},
                ]
            }
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight;
        this.query();
    },
    mounted(){
       
    },
    components: {
      ElImageViewer
    },
    methods: {
        saveStep(){
            this.stepFileList.forEach((x,i)=>{
                this.setRow.StepList[i].ImgList=[];
                x.forEach(c=>{
                    this.setRow.StepList[i].ImgList.push(c.url);
                })
            })
            taskOtherSaveStep({json:JSON.stringify(this.setRow.StepList)},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.stepVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        addStep(){
            let imgs=[];
            this.stepFileList.push(imgs);
            this.setRow.StepList.push({ ImgList:[],Img:"",Text:"",No: this.setRow.StepList.length+1,TaskId:this.setRow.Id})
        },
        pushStepImg(response){
            console.log(response);
            if(response.IsSuccess){
                this.stepFileList[response.Result].push({name:response.Message,url:response.Message});
            }else{
                this.$message.error('图片上传失败，请稍后重试');
            }
        },
        stepRemove(file){
             this.stepFileList.forEach(x=>{
                let index = x.indexOf(file);
                if (index > -1) {
                    x.splice(index, 1);
                }
             })        },
        setSetp(scope){
            if(scope.StepList.length>0){
                this.stepFileList=[];
                scope.StepList.forEach((x,i)=>{
                    this.stepFileList.push(new Array());
                    x.ImgList.forEach(c=>{
                        this.stepFileList[i].push({name:c,url:c})
                    })
                })
            }
            this.setRow=scope;
            this.stepVisible=true;
        },
        update(scope){
            this.model=scope;
            this.iconList=[{name:"icon",url:this.model.AppIcon}]
            if(scope.DeliverExampleList !=null&& scope.DeliverExampleList.length>0){
                this.deliverExampleList=[];
                scope.DeliverExampleList.forEach((x)=>{
                    this.deliverExampleList.push({name:x,url:x});
                })
            }
            this.addVisible=true;
        },
        exceed(){
            this.$message({
                message: '图片数量超过限制',
                type: 'warning'
            });
        },
        addAction(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.model.DeliverExampleList=[];
                    this.deliverExampleList.forEach(x=>{
                        this.model.DeliverExampleList.push(x.url);
                    })
                    taskOtherSave(this.model,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.addVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        iconRemove(){
            this.model.AppIcon="";
        },
        deliverRemove(file){
            let index = this.deliverExampleList.indexOf(file);
            if (index > -1) {
                this.deliverExampleList.splice(index, 1);
            }
        },
        pushIcon(response){
            if(response.IsSuccess){
                this.model.AppIcon=response.Message;
                console.log(this.model.AppIcon);
            }else{
                this.$message.error('图片上传失败，请稍后重试');
            }
        },
        pushDeliver(response){
            if(response.IsSuccess){
                this.deliverExampleList.push({name:response.Message,url:response.Message});
            }else{
                this.$message.error('图片上传失败，请稍后重试');
            }
        },
        handlePictureCardPreview(file){
            this.imgList=[file.url];
            this.showViewer=true;
        },
        add(){
            this.model={
                Id:0,
                AppName:"",
                Description:"",
                Income:0,
                Cost:0,
                DeliverDescription:"",
                DeliverExample:[],
                StepList:[],
                Sales:0,
                IsUse:false,
            };
            this.deliverExampleList=[];
            this.iconList=[];
            this.addVisible=true;
        },
        query(){
            this.isLoading=true;
            taskOtherGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
        showImg(list){
            this.imgList=list;
            this.showViewer=true;
        },
        closeImg(){
            this.showViewer=false;
        },
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>